
export interface ChatTargetInterface {
  getChats(): Array<number>
}

export function isChatTargetInterface(instance: any) : instance is ChatTargetInterface {
  return !!instance && typeof instance == 'object' && typeof instance.getChats === 'function';
}
